import { ArrowRight, Loader2 } from "lucide-react";
import { useAdvisor } from "@/advisor/AdvisorContext";
import { track } from "@/advisor/api";
import { metaAdvisorStart } from "@/lib/meta";

export const CHIPS = [
  { key: "restaurant", label: "Restoran", text: "Restoranım var." },
  { key: "salon", label: "Gözəllik salonu", text: "Gözəllik salonum var." },
  { key: "clinic", label: "Klinika", text: "Stomatoloji klinikam var." },
  { key: "carwash", label: "Avtoyuma", text: "Avtoyuma məntəqəm var." },
  { key: "store", label: "Mağaza", text: "Mağazam var." },
  { key: "tiktok", label: "TikTok LIVE", text: "TikTok-da canlı yayım edirəm." },
  { key: "other", label: "Digər", text: "" },
];

const markStarted = () => {
  if (sessionStorage.getItem("lm_started")) return;
  sessionStorage.setItem("lm_started", "1");
  track("started");
  metaAdvisorStart("input");
};

export const StepInput = ({ onSubmit, loading }) => {
  const { state, update } = useAdvisor();
  const valid = state.businessText.trim().length >= 3;

  const pick = (c) => {
    markStarted();
    update({ businessText: c.text, chipKey: c.key });
    if (!c.text) document.getElementById("business-input")?.focus();
  };

  return (
    <div className="adv-card p-4 sm:p-6 shadow-[0_0_60px_rgba(214,173,98,0.08)]" data-testid="advisor-step-input">
      <textarea
        id="business-input"
        data-testid="textarea-business-input"
        value={state.businessText}
        onFocus={markStarted}
        onChange={(e) => update({ businessText: e.target.value, chipKey: null })}
        rows={4}
        placeholder="Məsələn: Avtoyuma məntəqəm var və daha çox daimi müştəri cəlb etmək istəyirəm."
        className="adv-input"
      />
      <div className="flex flex-wrap gap-2 mt-4">
        {CHIPS.map((c) => (
          <button
            key={c.key}
            onClick={() => pick(c)}
            data-testid={`quick-chip-${c.key}`}
            data-active={state.chipKey === c.key}
            className="adv-option px-4 py-2 text-sm rounded-full"
          >
            {c.label}
          </button>
        ))}
      </div>
      <button
        className="adv-btn w-full mt-5 text-base"
        disabled={!valid || loading}
        onClick={onSubmit}
        data-testid="btn-show-solutions"
      >
        {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <>Həlləri göstər <ArrowRight className="h-5 w-5" /></>}
      </button>
      <p className="text-center text-xs text-[#a9a398] mt-3 font-mono">Pulsuz • 1 dəqiqə • Qeydiyyat tələb olunmur</p>
    </div>
  );
};
